import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://mvsjkhswkpefxssnyijs.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im12c2praHN3a3BlZnhzc255aWpzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE1MTk4NzMsImV4cCI6MjA2NzA5NTg3M30.hbGc0E9KGmtR59GwujLDivqLaDejGJwYLDkxCNNYkEQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Profile {
  id: string;
  username: string;
  avatar_url?: string;
  created_at: string;
  updated_at: string;
}

export interface World {
  id: string;
  name: string;
  thumbnail_url?: string;
  owner_id: string;
  settings: {
    max_users?: number;
    is_public?: boolean;
  };
  created_at: string;
  updated_at: string;
}

export interface WorldAsset {
  id: string;
  world_id: string;
  type: 'environment' | 'skybox' | 'content';
  url: string;
  metadata: {
    filename?: string;
    position?: [number, number, number];
    scale?: number;
    rotation?: [number, number, number];
    is_active?: boolean;
  };
  created_at: string;
}

export interface WorldAccess {
  world_id: string;
  user_id: string;
  role: 'owner' | 'invited' | 'viewer';
  created_at: string;
}

// Re-export avatar types from service for convenience
export type { Avatar, Credits, Transaction } from '../services/avatarService';
